// HomePage.js
import React from 'react';
import Header from '../common/Header'; // Ensure the path is correct
import SubHeaderForMSIL from './SubHeaderForMSIL';
import '../styles/HomePage.css';
import ParentDashboard from './ParentDashboard';

const AdminHome = () => {
  return (
    <div className='container-fluid d-flex flex-column w-100 p-0 m-0'>
      <Header />
      <div className='bg-secondary'><SubHeaderForMSIL /></div>
      <ParentDashboard />
    </div>
  );
};

export default AdminHome;
